import * as Yup from 'yup';

export const EditShopValidationSchema = Yup.object().shape({
    shopName: Yup.string().nullable().required('Required'),
    base64BranchImageString: Yup.mixed(),
});
